<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-50 o-dialog--lg-50 o-dialog--xl-50 o-dialog-h--85"
    :title="dialogTitle"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <el-form
      ref="form"
      class="c-form"
      :model="form"
      :rules="rules"
      :inline="true"
      label-position="right"
      label-width="150px"
      label-suffix="："
    >
      <el-row class="c-form__row">
        <el-col
          v-for="field in textFields"
          :key="field.prop"
          class="c-form__col"
          :span="field.span || 12"
        >
          <el-form-item
            class="c-form__item"
            :label="field.label"
            :prop="field.prop"
          >
            <span
              v-if="readOnly"
              class="c-form__read"
            >{{ displayValue(form[field.prop]) }}</span>
            <el-input
              v-else
              v-model.trim="form[field.prop]"
              :placeholder="`请输入${field.label}`"
            />
          </el-form-item>
        </el-col>

        <el-col
          v-for="field in numberFields"
          :key="field.prop"
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            :label="field.label"
            :prop="field.prop"
          >
            <span
              v-if="readOnly"
              class="c-form__read"
            >{{ displayValue(form[field.prop]) }}</span>
            <el-input-number
              v-else
              v-model="form[field.prop]"
              :min="0"
              :precision="field.precision"
              controls-position="right"
            />
          </el-form-item>
        </el-col>

        <el-col
          v-for="field in textareaFields"
          :key="field.prop"
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            :label="field.label"
            :prop="field.prop"
          >
            <textarea-read
              v-if="readOnly"
              v-model="form[field.prop]"
              class="c-form__read u-line-20"
            />
            <el-input
              v-else
              v-model.trim="form[field.prop]"
              type="textarea"
              :rows="3"
              :placeholder="`请输入${field.label}`"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        v-if="!readOnly"
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="handleSave"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog"
      />
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'JxxfPgBuildingDialog',
  props: {
    type: {
      type: String,
      default: 'add'
    },
    value: {
      type: Object,
      default: () => ({})
    },
    order: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      dialogShow: true,
      loading: false,
      form: {},
      textFields: [
        { prop: 'jzwbh', label: '建筑编号' },
        { prop: 'jzwmc', label: '建筑名称' },
        { prop: 'jzdz', label: '建筑地址', span: 24 },
        { prop: 'syxz', label: '使用性质' },
        { prop: 'nfdj', label: '耐火等级' },
        { prop: 'bncwz', label: '避难层位置' }
      ],
      numberFields: [
        { prop: 'zdmj', label: '占地面积（m²）', precision: 2 },
        { prop: 'jzmj', label: '建筑面积（m²）', precision: 2 },
        { prop: 'jzgd', label: '建筑高度（m）', precision: 2 },
        { prop: 'zlcs', label: '楼层数', precision: 0 },
        { prop: 'dscs', label: '地上层数', precision: 0 },
        { prop: 'dxcs', label: '地下层数', precision: 0 },
        { prop: 'aqcks', label: '安全出口数（个）', precision: 0 },
        { prop: 'sslts', label: '疏散楼梯数（个）', precision: 0 },
        { prop: 'xfdts', label: '消防电梯数（个）', precision: 0 }
      ],
      textareaFields: [
        { prop: 'xfssqk', label: '消防设施情况' },
        { prop: 'jzsm', label: '建筑说明' }
      ],
      rules: {
        jzwbh: [
          this.$validUtils.required('建筑编号'),
          this.$HMValidator.maxLength('建筑编号', 100)
        ],
        jzwmc: [
          this.$validUtils.required('建筑名称'),
          this.$HMValidator.maxLength('建筑名称', 300)
        ],
        jzdz: [
          this.$validUtils.required('建筑地址'),
          this.$HMValidator.maxLength('建筑地址', 300)
        ],
        syxz: [this.$HMValidator.maxLength('使用性质', 100)],
        nfdj: [this.$HMValidator.maxLength('耐火等级', 100)],
        bncwz: [this.$HMValidator.maxLength('避难层位置', 300)],
        xfssqk: [this.$HMValidator.maxLength('消防设施情况', 2000)],
        jzsm: [this.$HMValidator.maxLength('建筑说明', 2000)]
      }
    };
  },
  computed: {
    readOnly () {
      return this.type === 'view';
    },
    dialogTitle () {
      if (this.type === 'view') return '建筑信息查看';
      return this.type === 'edit' ? '建筑信息编辑' : '建筑信息新增';
    }
  },
  methods: {
    displayValue (value) {
      return value === null || value === undefined || value === '' ? '-' : value;
    },
    closeDialog () {
      this.$emit('close');
    },
    handleSave () {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.$emit('save', { ...this.form });
      });
    }
  },
  created () {
    this.form = {
      jzwbh: `JZW-${this.order}`,
      jzwmc: '',
      jzdz: '',
      syxz: '',
      nfdj: '',
      zdmj: 0,
      jzmj: 0,
      jzgd: 0,
      zlcs: 0,
      dscs: 0,
      dxcs: 0,
      aqcks: 0,
      sslts: 0,
      xfdts: 0,
      bncwz: '',
      xfssqk: '',
      jzsm: '',
      dyxh: this.order,
      ...this.value
    };
  }
};
</script>

<style scoped>
.el-input-number {
  width: 100%;
}
</style>
